import { render, staticRenderFns } from "./OrderDropshipper.vue?vue&type=template&id=5732d5a0&scoped=true"
import script from "./OrderDropshipper.vue?vue&type=script&lang=js"
export * from "./OrderDropshipper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5732d5a0",
  null
  
)

export default component.exports